"use client";
import { CommonPageHead } from "@highway/design-system";
import { HSnackbar, lightTheme } from "@highway/hwy-design-system";
import { Box, ThemeProvider } from "@mui/material";
import "../global.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";

export default function RootLayout({ children }: { children: React.ReactNode }) {
    // Stable across renders — a fresh QueryClient each render would discard the cache.
    const [queryClient] = useState(() => new QueryClient());

    return (
        <html lang="en">
            <CommonPageHead />
            <body>
                <ThemeProvider theme={lightTheme}>
                    <QueryClientProvider client={queryClient}>
                        <Box
                            sx={(theme) => ({
                                minHeight: "100vh",
                                height: "100%",
                                backgroundColor: theme.palette.extendedGrey2.main,
                                paddingBottom: "2rem",
                            })}
                        >
                            {children}
                        </Box>
                        <HSnackbar />
                    </QueryClientProvider>
                </ThemeProvider>
            </body>
        </html>
    );
}
